"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var S = _interopRequireWildcard(require("./wsLimitReachedStyle"));
var _crossIcon = _interopRequireDefault(require("./cross-icon.svg"));
var _wsIllustration = _interopRequireDefault(require("./ws-illustration.svg"));
var _greenTick = _interopRequireDefault(require("./green-tick.svg"));
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _common = require("apps/teacher/config/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WSLimitReachedPopup = function WSLimitReachedPopup(props) {
  (0, _react.useEffect)(function () {
    var eventProps = {
      from: 'Close',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)(),
      contentType: 'Worksheets'
    };
    _events["default"].viewedSubscribePopup(eventProps);
  }, []);
  var popupCloseHandler = function popupCloseHandler() {
    var eventProps = {
      clickedOn: 'Cross',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    };
    props.setShowLimitReachedPopup(false);
    if (window.parent.triggerIsFlutterHeaderClickDisabled) {
      window.parent.triggerIsFlutterHeaderClickDisabled();
    }
    _events["default"].interactedSubscribePopup(eventProps);
  };
  var onCtaClickHandler = function onCtaClickHandler() {
    var eventProps = {
      clickedOn: 'Unlock CTA',
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    };
    (0, _common.isFlutterUser)() ? window.parent.parent.location.href = '/dashboard#/purchase?source=printables&limit=0' : location.hash = '/purchase?source=printables&limit=0';
    _events["default"].interactedSubscribePopup(eventProps);
  };
  return /*#__PURE__*/_react["default"].createElement(S.PopupOverlay, {
    "data-sentry-element": "unknown",
    "data-sentry-component": "WSLimitReachedPopup",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.PopupWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.CrossButton, {
    onClick: popupCloseHandler,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_crossIcon["default"], {
    "data-sentry-element": "CrossButton",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.PopupHeader, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "You have no free worksheets left today"), /*#__PURE__*/_react["default"].createElement(S.PopupDetailsWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSImageWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.WSImage, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_wsIllustration["default"], {
    "data-sentry-element": "WSIllustration",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: props.worksheetDetails.image_url,
    alt: "worksheetImage"
  }))), /*#__PURE__*/_react["default"].createElement(S.TextWrapper, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListHeader, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Start your 7-day free trial to get:"), /*#__PURE__*/_react["default"].createElement(S.ListBody, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Full access to ", /*#__PURE__*/_react["default"].createElement("strong", null, "4400+ "), " Math & Reading worksheets")), /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "4000+ "), " curriculum aligned games & activities")), /*#__PURE__*/_react["default"].createElement(S.ListItem, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(S.ListIcon, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_greenTick["default"], {
    "data-sentry-element": "GreenTick",
    "data-sentry-source-file": "wsLimitReached.tsx"
  })), /*#__PURE__*/_react["default"].createElement(S.ListText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Comprehensive weekly progress reports"))))), /*#__PURE__*/_react["default"].createElement(S.CtaButton, {
    onClick: onCtaClickHandler,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "Start free trial for unlimited downloads"), /*#__PURE__*/_react["default"].createElement(S.FooterText, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "wsLimitReached.tsx"
  }, "You won't be charged upfront")));
};
var _default = WSLimitReachedPopup;
exports["default"] = _default;